import bootstrapYM from './bootstrap';
import { GoalType } from './declare';
import convertToType from './helpers/convertToType';
import { formatErrorParams } from './Rules/error';
import generalRules from './Rules/general';

type Data = Record<string, any>;

export interface TriggerYMParams<T> {
    data?: T & Data;
    goal: GoalType;
}

const YMGoal = bootstrapYM();

export function triggerYM<T>(params: TriggerYMParams<T>) {
    const { data, goal } = params;

    let dataToSend = {};

    switch (goal) {
        case GoalType.DEV:
            dataToSend = formatErrorParams(convertToType(data));
            break;

        default:
            dataToSend = generalRules(convertToType(data));
            break;
    }

    YMGoal(goal, dataToSend);
}
